import { ENTITY_TAB_POSTS_ORDERING_SELECT_OPTIONS } from './EntityTabPostsToolbar.constants'

export function getTranslatedOrderingOptions(t) {
  return ENTITY_TAB_POSTS_ORDERING_SELECT_OPTIONS.map(option => ({
    ...option,
    label: t(option.label),
  }))
}
